// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {actions as CheckoutStepActions} from '../../CheckoutStep/duck';
import { actions as ProductStepActions } from '../duck';
import { actions as ShoppingCartActions } from '../../../shopping-cart/duck';
import { actions as BagActions } from '../../../bag/duck';
import { actions as ScrapActions } from '../../../scrap/duck';
import { actions as AlertActions } from '../../../alert/duck';
import ProductStep from '../components/ProductStep';
import { push } from 'react-router-redux';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    chosenVariants: state.abTest.chosenVariants,
    localeState: state.locale,
    localValues: state.localValues,
    preloadedProduct: state.newOrder.preloadedProduct,
    /*wishLists: state.newOrder.productStep.wishLists,
    isPostingProduct: state.newOrder.productStep.isPostingProduct,
    isPostingNewWishList: state.newOrder.productStep.isPostingNewWishList,
    postProductSuccess: state.newOrder.productStep.postProductSuccess,
    postNewWishListError: state.newOrder.productStep.postNewWishListError,*/
    isPostingBag: state.bag.isPostingBag,
    postBagItemError: state.bag.postBagItemError,
    isPostingCartItem: state.shoppingCart.isPostingCartItem,
    postCartItemSuccess: state.shoppingCart.postCartItemSuccess,
    postCartItemError: state.shoppingCart.postCartItemError,
    virtualShoppingCart: state.shoppingCart.virtualShoppingCart,
    virtualBag: state.bag.virtualBag,
    isScrappingUrl: state.scrap.isScrappingUrl,
    scrappedProduct: state.scrap.scrappedProduct,
    scrapSuccess: state.scrap.scrapSuccess,
    scrapUrlError: state.scrap.scrapUrlError,
    forecast: state.newOrder.productStep.forecast,
    isLoadingForecast: state.newOrder.productStep.isLoadingForecast,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ProductStepActions, ...ShoppingCartActions, ...BagActions, ...ScrapActions, ...AlertActions,
    goToRedirect: (route) => push(route),
    checkoutFetchCheckoutDataSuccess: CheckoutStepActions.fetchCheckoutDataSuccess,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductStep);



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/containers/ProductStepContainer.jsx